import SkeletonUI from '@/components/skeleton-ui'
export default {
  components: {
    SkeletonUI
  },
  props: {
    providerInfo: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    providerInfo: {
      deep: true,
      handler: async function(to, from) {
        await this.initialise()
      }
    }
  }
}
